import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from '../../../../core/util/core/Fetch';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function Data() {
    const profileFilter = chooseProfileFilter();

    const hiddenValues = {};

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id;
    }

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/gci/suppliers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'gci/suppliers/save',
        endpointGetById: config.endpoints.backend + 'gci/suppliers/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'gci/companies/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleEdit: 'Editar Fornecedor',
        labelTitleView: 'Visualizar Fornecedor'
    };

    const getForm = (values) => {
        const supplier_type = values.supplier_type;

        const form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues,
                ...(id && { id })
            },
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: { required: true },
                    columnSize: 12
                } : {},
                {
                    name: 'supplier_type',
                    type: 'select',
                    options: [
                        { label: 'Física', value: 'F' },
                        { label: 'Jurídica', value: 'J' },
                        { label: 'Estrangeiro', value: 'E' },
                        { label: 'Sem documento', value: 'S' }
                    ],
                    label: 'Tipo de Fornecedor',
                    validations: { required: true },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        const form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />
                        );
                    }
                },
                ...(['F', 'E', 'S'].includes(supplier_type)
                    ? [
                          {
                              name: 'name',
                              type: 'text',
                              label: 'Nome',
                              validations: { required: true },
                              columnSize: 12
                          },
                          supplier_type === 'F'
                              ? {
                                    name: 'cpf',
                                    type: 'CPF',
                                    label: 'CPF',
                                    validations: { required: true },
                                    columnSize: 4
                                }
                              : {
                                    name: 'document',
                                    type: 'text',
                                    label: 'Documento',
                                    validations: { required: supplier_type === 'E' },
                                    columnSize: 4
                                },
                          {
                              name: 'rg',
                              type: 'RG',
                              label: 'RG',
                              validations: { required: false },
                              columnSize: 4
                          },
                          {
                              name: 'birth_date',
                              type: 'date',
                              label: 'Data de Nascimento',
                              validations: { required: false },
                              columnSize: 4
                          }
                      ]
                    : [
                          {
                              name: 'corporate_name',
                              type: 'text',
                              label: 'Razão Social',
                              validations: { required: true },
                              columnSize: 12
                          },
                          {
                              name: 'fantasy_name',
                              type: 'text',
                              label: 'Nome Fantasia',
                              validations: { required: false },
                              columnSize: 12
                          },
                          {
                              name: 'cnpj',
                              type: 'CNPJ',
                              label: 'CNPJ',
                              validations: { required: true },
                              columnSize: 6
                          },
                          {
                              name: 'estadual_registration',
                              type: 'text',
                              label: 'Inscrição Estadual',
                              validations: { required: false },
                              columnSize: 6
                          },
                          {
                              name: 'opening_date',
                              type: 'date',
                              label: 'Data de Abertura',
                              validations: { required: false },
                              columnSize: 6
                          }
                      ]),
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: { required: true },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id });
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}

export default Data;
